import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Const} from '../const/const';
import {Role} from '../models/role.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

    constructor(private http: HttpClient) {}

    createAccount(data: any) {
        return this.http.post(Const.baseAPI + '/register', data);
    }

    getUserProfile() {
        return this.http.get(Const.baseAPI + '/get-user-profile');
    }

    getRoleByEmail(email: string) {
        return this.http.get(Const.baseAPI + '/get-role-by-email/' + email);
    }

    updateUserProfile(data: any, type: string) {
        return this.http.post(Const.baseAPI + '/update-user-profile/' + type, data);
    }

    forgotPassword(email: any) {
        return this.http.post(Const.baseAPI + '/forgot-password', email);
    }

    passwordReset(data: any) {
        return this.http.post(Const.baseAPI + '/reset-password', data);
    }

    confirmEmail(data: any) {
        return this.http.post(Const.baseAPI + '/confirmAccount', data);
    }

    confirmEmailByCode (data: any) {
        return this.http.post(Const.baseAPI + '/confirm-email-by-code', data);
    }

    foreignAccount(data: any) {
        return this.http.post(Const.baseAPI + '/foreign-account', data);
    }

  getAllUser(index: number, itemPerPage: number, search?: string, status?: number) {
    let url = `${Const.baseAPI}/get-all-user/${index}/${itemPerPage}`;
    let params = [];
    if (search) {
      params.push(`search=${search}`);
    }
    if (status !== undefined && status !== null) {
      params.push(`status=${status}`);
    }
    if (params.length > 0) {
      url += '?' + params.join('&');
    }
    return this.http.get(url);
  }
  getAllPendingUser(q: string = '') {
    const params: any = {};
    const keyword = (q || '').trim();
    if (keyword) params.q = keyword;

    return this.http.post<string[]>(
      `${Const.baseAPI}/get-all-pending-user`,
      { params }
    );
  }


  reVerifyPendingUser(emails: string[]) {
    const body = {
      listUser: emails
    };
    return this.http.post(`${Const.baseAPI}/re-verify-account`, body);
  }

  superAdminCreateAccount(data: any) {
        return this.http.post(Const.baseAPI + '/admin-create-account', data);
    }

    deactiveUser(userId: number) {
        return this.http.post(Const.baseAPI + '/deactive-user/' + userId, null);
    }

    activeUser(userId: number) {
        return this.http.post(Const.baseAPI + '/active-user/' + userId, null);
    }

    getUserById(id: number) {
        return this.http.get(Const.baseAPI + '/get-user-by-id/' + id);
    }

    updateProfileUser(profile: any, user_id: number) {
        return this.http.post(Const.baseAPI + '/update-profile-user/' + user_id, profile);
    }

    changePassword(data: any) {
        return this.http.post(Const.baseAPI + '/change-password', data);
    }

    changeEmailAddress(email: string) {
        return this.http.post(Const.baseAPI + '/change-email', email);
    }

    checkChangeEmailAddress(userId: number) {
        return this.http.get(Const.baseAPI + '/check-change-email/' + userId);
    }

    cancelChangeEmailAddress(userId: number) {
        return this.http.post(Const.baseAPI + '/cancel-change-email/' + userId, null);
    }

    detachRoleUser(userId: number, roleName: string) {
        return this.http.get(Const.baseAPI + '/detach-role/' + userId + '/' + roleName);
    }

    removeAccount(data: any) {
      return this.http.post(Const.baseAPI + '/remove-account', data);
    }

    sendContactListUser(data: any): Observable<any> {
      return this.http.post(Const.baseAPI + '/contact/sendContactListUser', data);
    }

    sendContactApplicant(data: any): Observable<any> {
      return this.http.post(Const.baseAPI + '/contact/sendContactApplicant', data);
    }

    sendContactOwner(data: any): Observable<any> {
        return this.http.post(Const.baseAPI + '/contact/sendContactOwner', data);
    }

    sendContactUser(data: any): Observable<any> {
        return this.http.post(Const.baseAPI + '/contact/sendContactUser', data);
    }

    checkUserActive(jobId: number) {
        return this.http.get<any>(Const.baseAPI + '/checkUserActive/' + jobId);
    }

    downLoadDataUser(userId: number) {
        return this.http.get<any>(Const.baseAPI + '/downLoadDataUser/' + userId);
    }

    checkRole(role: Role[]) {
        for (let r of role) {
            if (r.name === 'job_seeker') {
              return r.name;
            }

            if (r.name === 'employer') {
              return r.name;
            }
        }
        return 'administrator';
    }

    checkAdmin(role: Role[]) {
        for (let r of role) {
            if (r.name === 'administrator' || r.name === 'superadministrator') {
              return r.name;
            }
        }
        return null;
    }
}
